<template>
<ValidationObserver v-slot="{ handleSubmit }">
  <form @submit.prevent="handleSubmit(submit)">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title">
          {{ form.id ? 'Update Route' : 'Create New Route' }}
        </h4>
      </div>
      <div class="card-body">
        <div class="form-group">
          <label>Port of Origin</label>
          <ValidationProvider name="port_origin_id" rules="required" v-slot="{ passed, failed }">
            <el-select v-model="form.port_origin_id" placeholder="Select" filterable class="form-group" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
              <el-option :value="p.id" :label="p.name" v-for="p in ports" :key="p.id">{{ p.name }}</el-option>
            </el-select><br>
            <span class="error-text" v-if="failed">Port of origin is required</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Port of Destination</label>
          <ValidationProvider name="port_dest_id" rules="required" v-slot="{ passed, failed }">
            <el-select v-model="form.port_dest_id" placeholder="Select" filterable class="form-group" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
              <el-option :value="p.id" :label="p.name" v-for="p in ports" :key="p.id">{{ p.name }}</el-option>
            </el-select><br>
            <span class="error-text" v-if="failed">Port of destination is required</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Travel Time (Hours)</label>
          <ValidationProvider name="travel_time" rules="required|double" v-slot="{ passed, failed }">
            <el-input v-model="form.travel_time" placeholder="0.00" class="form-group" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
            </el-input><br>
            <span class="error-text" v-if="failed">Travel time is not valid</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Is Online</label><br>
          <el-switch v-model="form.is_online" active-text="Yes" inactive-text="No">
          </el-switch>
        </div>
        <div class="form-group">
          <label>Online Addon Fee</label>
          <ValidationProvider name="online_add_on_fee" rules="double" v-slot="{ passed, failed }">
            <el-input v-model="form.online_add_on_fee" placeholder="0.00" class="form-group" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
            </el-input><br>
            <span class="error-text" v-if="failed">Online add on fee is not valid</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Online Cut-Off Time (Minutes)</label>
          <ValidationProvider name="online_cut_off_minutes" rules="double" v-slot="{ passed, failed }">
            <el-input v-model="form.online_cut_off_minutes" placeholder="0.00" class="form-group" :class="[
                { 'has-danger': failed },
                { 'has-success': passed }]">
            </el-input><br>
            <span class="error-text" v-if="failed">Value is not valid</span>
          </ValidationProvider>
        </div>
        <div class="form-group">
          <label>Auto Assign Seat</label>
          <ValidationProvider name="assign_automatic_seat_number" >
              <el-checkbox v-model="form.assign_automatic_seat_number" size="large" border></el-checkbox>
          </ValidationProvider>
        </div>
      </div>
      <div class="card-footer text-right">
        <p-button type="info" native-type="submit">Save</p-button>
      </div>
    </div>
  </form>
</ValidationObserver>
</template>

<script>
import {
  extend
} from "vee-validate";
import {
  required, double
} from "vee-validate/dist/rules";
import {
  Route
} from '@/resources/route'
import {
  Port
} from '@/resources/port'

extend("required", required);
extend("double", double);

export default {
  props: ['route'],
  data() {
    return {
      form: {
        code: "",
        port_origin_id: null,
        port_dest_id: null,
        travel_time: 0,
        online_add_on_fee: null,
        online_cut_off_minutes: 30,
        is_online: true
      },
      ports: []
    };
  },
  watch: {
    route: function () {
      if (this.route) this.form = Object.assign({}, this.route)
    }
  },
  created: function () {
    if (this.route) this.form = Object.assign({}, this.route)
    this.getPorts()
  },
  beforeDestroy() {
    this.form = {
      code: "",
    }
  },
  methods: {
    getPorts() {
      let params = {}
      this.$loading = true
      Port.get({
          params: params
        })
        .then(result => {
          if (result.data.ports)
            this.ports = result.data.ports
        })
        .catch(() => {
          this.$notify({
            type: 'danger',
            title: "Error",
            text: 'Unable to fetch ports',
          });

        }).finally(() => {
          this.$loading = false
        })
    },
    submit() {
      this.$loading = true

      let request = this.form.id ? Route.update(this.form) : Route.create(this.form)

      request
        .then(result => {
          this.$notify({
            type: 'success',
            title: "Success",
            text: 'Route has been saved',
          });
          this.$emit('save', true)
        })
        .catch(error => {

        }).finally(() => {
          this.$loading = false
        })
    }
  }
}
</script>

<style></style>
